export class BrowserIdentifierUtil {

    public static getBrowserName(): string {
        const agent = window.navigator.userAgent.toLowerCase();
        const browser =
          agent.indexOf("edge") > -1 ? "Microsoft Edge"
              : agent.indexOf("edg") > -1 ? "Chromium-based Edge"
                  : agent.indexOf("opr") > -1 ? "Opera"
                      : agent.indexOf("chrome") > -1 ? "Chrome"
                          : agent.indexOf("trident") > -1 ? "Internet Explorer"
                              : agent.indexOf("firefox") > -1 ? "Firefox"
                                  : agent.indexOf("safari") > -1 ? "Safari"
                                      : "other";

        return browser;
    }

    public static isSafari(): boolean {
        return BrowserIdentifierUtil.getBrowserName() === "Safari";
    }

    public static isMac(): boolean {
        const agent = window.navigator.userAgent.toLowerCase();
        return /macintosh/.test(agent); 
    }

    public static getOSName(): string {
        const userAgent = navigator.userAgent;
        if (/Windows/.test(userAgent)) {
            return "Windows";
        }

        if (/Mac/.test(userAgent)) {
            return "macOS";
        }

        if (/Linux/.test(userAgent)) {
            return "Linux";
        }

        if (/Android/.test(userAgent)) {
            return "Android";
        }

        if (/iPhone|iPad|iPod/.test(userAgent)) {
            return "iOS";
        }

        return "Unknown";
    }

    public static isIOS(): boolean {
        return this.getOSName() === "iOS";
    }

}
